import { useCallback, useEffect, useState } from "react";
import MainHeader from "../../../components/mainheader/MainHeaderNew";
import StickySidebar from "../../../components/stickysidebar/StickySidebar";
import MainFooter from "../../../components/mainfooter/MainFooter";
import { axiosInstance, REACT_APP_URL } from "../../../config";
import { fetchAboutUs } from "../../../redux/slices/aboutUsSlice";
import { useDispatch } from "react-redux";

import { toastError } from "../../../utils/reactToastify";

import "../PrivacyPolicy/style.css";
import { Link } from "react-router-dom";

const TermsandCondition = () => {
  const dispatch = useDispatch();
  const [headerImage, setHeaderImage] = useState({});
  const fetchRootCollection = useCallback(async () => {
    try {
      const { data } = await axiosInstance.get(
        `/api/header-image/title/TermsandCondition`
      );
      if (data?.success) {
        setHeaderImage(data?.data);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toastError(error?.response?.data?.message);
      } else {
        toastError(error?.message);
      }
    }
  }, []);
  useEffect(() => {
    fetchRootCollection();
  }, [fetchRootCollection]);
  useEffect(() => {
    dispatch(fetchAboutUs());
  }, [dispatch]);

  return (
    <div style={{ backgroundColor: "#dadada96" }}>
      <StickySidebar />
      <MainHeader isImageAvailable={headerImage?.pngImage ? true : false} />
      <div
        className="div"
        style={{
          height: headerImage?.pngImage ? "60vh" : "11vh",
          overflow: "hidden",
          position: "relative",
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.5)), url(${REACT_APP_URL}/images/header/${headerImage?.pngImage})`,
          backgroundSize: "cover",
        }}
      ></div>{" "}
      <div className="container py-3 policy-content">
        <h1 className="mb-4">
          Terms & Conditions for Railingo Private Limited
        </h1>
        <p>
          <strong>Effective Date:</strong> April 1, 2025
        </p>

        <p>
          Welcome to <Link href="https://railingo.com/">www.railingo.com</Link>,
          the official website of Railingo Private Limited. These Terms &
          Conditions ("Terms") govern your access to and use of our website,
          including any content, functionality, and services offered on or
          through <Link href="https://railingo.com/">www.railingo.com</Link>{" "}
          (the "Website").
        </p>

        <p>
          Please read these Terms carefully before you start to use the Website.
          <span>
            By using the Website, making an inquiry, placing an order, or
            otherwise engaging with us through the Website, you accept and agree
            to be bound and abide by these Terms, our Privacy Policy, and our No
            Cancellation & No Alteration Policy.
          </span>
          If you don't agree to these Terms, the Privacy Policy, or the No
          Cancellation & No Alteration Policy, you must not access or use our
          Website or engage in a transaction with us.
        </p>

        <h4>1. Definitions</h4>
        <ul>
          <li>
            <strong>"Company," "We," "Us," "Our":</strong> Refers to Railingo
            Private Limited, a company incorporated under the laws of India,
            with its registered office at Plot no. 149, Sector 4, IMT Manesar,
            Gurugram, Haryana - 122051.
          </li>
          <li>
            <strong>"Customer," "Client," "Buyer," "You," "Your": </strong>{" "}
            Refers to any person or entity using the Website, making an inquiry,
            or placing an order for Products. This includes individuals,
            architects, interior designers, contractors, and businesses.
          </li>
          <li>
            <strong>"Website": </strong> Refers to{" "}
            <Link href="https://railingo.com/">www.railingo.com</Link>.
          </li>
          <li>
            <strong>"Products": </strong> Refers to the architectural metal
            products, including but not limited to facades, doors, gates,
            railings, and any other items offered for sale or customization by
            the Company. This includes both "Customized Products" and "Standard
            Products."
          </li>
          <li>
            <strong>"Customized Products": </strong> Refers to Products
            designed, manufactured, or altered specifically to Your unique
            specifications, designs, or requirements.
          </li>
          <li>
            <strong>"Standard Products":</strong> Refers to pre-designed or
            ready-made Products from the Company's standard catalog.
          </li>
          <li>
            <strong>"Order Confirmation": </strong> Refers to the Company's
            written acceptance of Your order, which may be in the form of an
            email, proforma invoice, or signed agreement. A contract commences
            once Railingo Pvt. Ltd. has received the signed order and any
            initial deposit payment.
          </li>
        </ul>

        <h4>2. Use of the Website</h4>
        <p>
          2.1. <span>Eligibility: </span>By using this Website, you represent
          and warrant that you are at least 18 years of age and are legally
          capable of entering into binding contracts.
        </p>
        <p>
          2.2. <span>Website Access:</span> We grant you a limited,
          non-exclusive, non-transferable, and revocable license to access and
          use the Website for personal and commercial informational purposes in
          accordance with these Terms.
        </p>
        <p>
          2.3. <span>Prohibited Uses: </span> You agree not to use the Website:
          * In any way that violates any applicable federal, state, local, or
          international law or regulation. * To engage in any conduct that
          restricts or inhibits anyone's use or enjoyment of the Website, or
          which, as determined by us, may harm the Company or users of the
          Website. * To upload or transmit any computer viruses, worms, or any
          software intended to damage or alter a computer system or data. * To
          attempt to gain unauthorized access to any portion or feature of the
          Website, or any other systems or networks connected to the Website.{" "}
          <span>
            * To infringe upon or violate our intellectual property rights or
            the intellectual property rights of others.
          </span>
        </p>

        <h4>3. Pricing & Validity</h4>
        <p>
          3.1. <span> Quotation Basis & Validity: </span> This quotation is
          based on the dimensions, drawings, or sketches provided to us. The
          quotation is valid for a period of <span> 10 days </span>from the date
          of issuance, unless otherwise stated. Railingo reserves the right to
          revise the quotation after the expiry of the validity period.
        </p>
        <p>
          3.2. <span> Pricing Alterations: </span> Any changes in design or
          sizes from the provided dimensions/drawings will affect the pricing.
          Itemized Average Price (Per Sq. Ft) is valid for a size variation of
          (+/-) 25mm only for the given design. Any changes in the design report
          will also result in a change in pricing and discount structure.
        </p>
        <p>
          3.3. <span> Dimension Variations: </span> In case of variations of
          more than 100mm in height or width of a Product at the time of site
          measurement compared to design dimensions, prices will be recalculated
          and adjusted accordingly.
        </p>
        <p>
          3.4. <span> Taxes: </span>GST at{" "}
          <span>18% will be charged extra. </span> Any increase or decrease in
          taxation will be charged or passed on, as per the prevailing rate at
          the time of actual supply or billing. No separate notice of such
          change in taxes etc. shall be given during the execution of the
          project.
        </p>
        <p>
          3.5. <span> Price Escalation: </span> In case the project completion
          period, as proposed by you, delays on your part, an additional{" "}
          <span> 8% of the total value </span> will be charged by us as price
          escalation. 3.6. <span> Product Design Modifications:</span> Railingo
          Pvt. Ltd. reserves the right to modify product designs and
          specifications without prior notice to improve product quality or
          manufacturing processes.
        </p>

        <h4>4. Order Confirmation & No Cancellation/No Alteration Policy</h4>
        <p>
          4.1. <span>Order Acceptance:</span> All orders are subject to
          acceptance by Railingo Pvt. Ltd.
        </p>

        <p>
          4.2.<span> No Cancellation & No Alteration:</span> Once an order for
          any Railingo Product (whether Customized or Standard) has received
          <span>Order Confirmation</span>, it cannot be cancelled, modified, or
          altered. This policy is strictly upheld due to the immediate
          commitment of resources (material procurement, design work, specific
          product allocation, production scheduling) that occurs upon order
          confirmation, which are uniquely tied to Your specific order and
          cannot be easily repurposed or re-allocated. If a modification is
          brought forward, a new quote shall be made, and that modification
          should be treated as a new order and a new Product.{" "}
          <span>
            No changes in the design or sizes are possible after fabrication of
            Products.
          </span>
        </p>

        <p>
          4.3.<span> Finality of Designs:</span> Once the concept design and
          drawings are signed off by the Client, no further changes are
          permitted. Variations in quantity, size, or design made post-signing
          will alter the prices accordingly.
        </p>

        <h4>5. Payment Terms</h4>
        <p>
          5.1.<span> General Payment:</span> Payment shall be made by the Client
          to Railingo in accordance with the payment terms specified in the
          quotation.
        </p>

        <p>
          5.2.<span> Standard Payment:</span> Payment terms are{" "}
          <span>
            60% advance along with Purchase Order and 40% Before Dispatch From
            Our Works.
          </span>
        </p>

        <p>
          5.3.<span> Multi-Unit Projects:</span> In the case of multiple units
          (e.g., flats), payments need to be made per flat completion and upon
          receipt of the corresponding bill.
        </p>

        <p>
          5.4.<span> No Deviations:</span> There would be no deviation made in
          the payment terms unless explicitly agreed upon in writing by an
          authorized representative of Railingo Pvt. Ltd.
        </p>

        <p>
          5.5.<span> Glass Payment:</span> If the Client opts to purchase glass
          directly from a vendor, the glass payment is to be done by the Client
          directly to that glass vendor and will not be part of Railingo Pvt.
          Ltd.'s invoice.
        </p>

        <h4>6. Delivery Terms & Conditions</h4>
        <p>
          6.1.<span> Delivery Timelines:</span> Railingo will use reasonable
          efforts to meet the agreed delivery timelines, but delays may occur
          due to unforeseen circumstances. Railingo shall not be liable for any
          damages or losses arising from such delays. Any delays due to
          unforeseen circumstances will be communicated promptly to the Client.
        </p>

        <p>
          6.2.<span> Transportation & Unloading Costs:</span> Freight from the
          factory to your destination will be <span>payable by the Buyer,</span>{" "}
          unless the same is explicitly added in the above quote. Transportation
          and unloading costs will be as per actuals and shall be borne by the
          Client, unless otherwise explicitly agreed upon in writing.
        </p>

        <p>
          6.3.<span> Risk Transfer:</span> The risk and responsibility of the
          material transfer to the Client immediately upon delivery at the
          designated site.
        </p>

        <p>
          6.4.<span> Failure to Take Delivery:</span> If the Client fails to
          take delivery of the ready material within 10 days of the agreed date,
          Railingo Pvt. Ltd. will not be responsible for any goods damage, and
          warehouse charges will be applicable at{" "}
          <span>1% of the order value per day.</span>
        </p>

        <p>
          6.5.<span>Transit Insurance:</span> A transit insurance charge of
          <span>2.95%</span> will be applied. This insurance will only cover
          breakages that occur during transit. When transporting goods, if there
          is any dent or damage during transit, it will be covered only if there
          is insurance; otherwise, it will remain the Client's responsibility.
          This insurance does not cover damages occurring after delivery to the
          site.
        </p>

        <h4>7. Product Specific Conditions</h4>

        <p>
          7.1. <span>Manufacturing Standards:</span> All customizable products are manufactured as per industry
          standards and strictly adhere to the design specifications approved by the Client.
        </p>
        <p>
          7.2. <span>Post-Approval Alterations:</span> Any alterations to sizes, designs, or specifications requested
          post-approval will be considered a new order and will be chargeable at prevailing rates.
        </p>
        <p>
          7.3. <span>Steel Doors:</span> Steel doors must be stored in dry conditions to prevent warping and damage.
          Railingo Pvt. Ltd. is not liable for issues arising from improper storage.
        </p>
        <p>
          7.4. <span>Railings:</span> Railings are designed for structural integrity. However, proper maintenance as per
          recommended guidelines is required by the Client to ensure long-term durability and aesthetic
          appeal.
        </p>
        <p>
          7.5. <span>Facades:</span> Facades must be installed on structurally sound walls. Any necessary structural
          reinforcements or civil works required to prepare the wall for facade installation will be under the
          Client's scope and responsibility.
        </p>
        <p>
          7.6. <span>Customization Finishes:</span> Customization options, including powder coating and anodized
          finishes, will adhere to industry standards and client preferences as specified in the approved
          design.<span> Powder Coatings/Solid color coatings are typically 60-70 microns in thickness.</span>
        </p>
        <p>
          7.7. <span>Manufacturing Sizes:</span> Window civil opening size will be considered for the billing. Window
          fabrication tolerance will be 5-6mm from height & width.
        </p>
        <p>
          7.8. <span>Glass Quality:</span> Glass used is AIS/Saint Gobain specified by <span> Railingo</span>. Glass quality will be
          maintained as per ASTM C 1036-06 (Quality level 3). The glass specification is as per
          customer's demand, which is clearly mentioned in the quotation.
        </p>
        <p>
          7.9. <span>Aluminum Quality:</span> Aluminum used for fabrication is of T6 Grade as provided by <span> Railingo</span>.
        </p>
        <p>
          7.10. <span>Product Protection:</span> It is critical to protect each and every installed Product by packing
          them, which is under the Customer's scope, especially when other jobs are parallel going on at
          the site. After the product is installed, the responsibility for packing will not lie with the
          company's team. Any packing required will be done by the client, and if the client requests
          packing after installation, it will incur additional charges.
        </p>
        <p>
          7.11.<span> Protection Tape:</span> Removing the protection tape immediately after the installation is
          necessary and included in this scope. However, if this protection tape is not removed within 15
          days of installation on the request of the client representative, it might leave glue and stick to the
          frame so badly that removing it will not be possible. The same will have to be removed by the
          Client's representative, and Railingo Pvt. Ltd. will not be responsible for any transfer of glue to
          the profile nor be liable to clean the same. Glass & Aluminum Profile protection tape is not
          under our scope of work for supply.
        </p>
        <p>
          7.12. <span>Replacement of Product:</span> In case of replacement of a Product, the replaced Product will
          be considered a new purchase. Removal charge for the old Product and its disposal will be the
          Client's responsibility.
        </p>
        <p>
          7.13. <span>Excluded Accessories:</span> Door closers, door stoppers, and similar machines are always
          separate and are not included in our quote.
        </p>

        <h4>8. Site Conditions & Client Responsibilities</h4>
        <p>
          8.1. <span>Site Preparation Prerequisites:</span> Buyer has to provide clear and correct 90-degree civil
          openings for installation. All apertures should be properly finished. All jambs, sills, and soffits
          should be plastered/stone/tile installed. Base and top of apertures should be in water level, and
          sides should be in vertical plumb. Openings should be accessible from the inside. Rectification
          of walls or openings, if required, to maintain minimum gaps for installation, must be done by the
          Client. Pre & Post inspection of the site will be jointly carried out by Railingo Pvt. Ltd. and the
          Client's site supervisor
        </p>
        <p>
          8.2. <span>On-Site Material Storage & Security:</span> An adequate, safe, and secure store should be
          provided by the Client at the site for storing consumables, and adequate safe space should be
          given at Stilt/Ground Floor level to store Products. In case of theft or damage (including force
          majeure events), the stored materials shall be adequately insured by the Customer, and their
          value should be reimbursed to the Company.
        </p>
        <p>
          8.3. <span>Material Responsibility On-Site:</span> Material responsibility lies solely with the Client once
          delivered to the site. Railingo Pvt. Ltd. is not responsible for any damage or breakage of
          materials once installed at site. If any damages or any breakages happen on site (e.g., due to
          working at site such as HVAC, civil contractors, P.O.P & paint works), Railingo Pvt. Ltd. will not
          be responsible for that, nor will it be our responsibility to clean the windows or glass. Any
          replacement if required will be on a chargeable basis.
        </p>
        <p>
          8.4. <span>Client-Provided Resources for Installation (Free of Cost):</span> The Client must arrange for
          and provide, at no extra cost to Railingo Pvt. Ltd.: * Labor union charges (Hamali Charge). * The
          provision of electricity and other necessary facilities should be provided from Client's side to the
          team. * Hoist lift for the lifting of larger glass and Products. * Safe storage for Door Panels and
          Tracks in a store. * All necessary scaffolding and wooden templates. * Any required safety nets
          at dangerous locations during installation.

        </p>
        <p>
          8.5. <span>Scope of Work Exclusions:</span> Our scope is strictly restricted to Product installation. Any
          cutting/repair of R.C.C, stone or brick work, flooring or plastering etc., for fixing the frame is not
          in our work scope. Any kind of MS work needed is in the Client's scope. Clients must obtain all
          necessary permissions and approvals from relevant authorities before installation commences.

        </p>

        <h4>9. Manufacturing & Installation Process</h4>
        <p>
          9.1. <span>Order Finalisation & Kick-off:</span> Order finalisation and signing off the closure documents are
          required. A kick-off meeting at the site with Sales, Technical Supervisor, and Client's Site
          Supervisor/Client will be held.
        </p>
        <p>
          9.2. <span>Drawing and Colour Approvals:</span> Drawings and colour approvals are to be obtained from
          the Client/Architect.
        </p>
        <p>
          9.3. <span>Procurement Period for Large Orders:</span> A <span>90-day material procurement time</span> is required
          before the start of production for orders more than 10,000 sq. ft.
        </p>
        <p>
          9.4. <span>Part Production:</span> Railingo Pvt. Ltd. will not execute part production for projects under
          10,000 sq. ft. Any requirement of carrying out part production post finalization of quote will incur
          additional charges needed for additional resources used.
        </p>
        <p>
          9.5. <span>Site Survey for Smaller Projects:</span> For projects under 10,000 sq. ft., a site survey will be
          carried out only once all apertures are ready as per Railingo Pvt. Ltd.'s requirements.
        </p>
        <p>
          9.6. <span>Final Measurements:</span> Final measurements for fabrication of Products shall be taken only
          after we are provided with complete and clear openings that are smooth, with base and top in
          water level, and sides in vertical plumb. These final measurements will be strictly in accordance
          with the closure document.
        </p>
        <p>
          9.7. <span>Production Start:</span> Production will commence a minimum of 30 days from the final
          measurement approval (Step 6).
        </p>
        <p>
          9.8. <span>Delivery:</span> Delivery is subject to clearance of payment.
        </p>
        <p>
          9.9. <span>Installation Commencement:</span> It is important that Products should be installed at the end of
          the construction work. It is recommended, and we will only start installation once all the wet
          work is over and two coats of paint are done on site. The site must be cleared by Railingo Pvt.
          Ltd. personnel before dispatch of materials to ensure Products will face less harsh conditions
          once installed and chances of damage will be minimal.
        </p>
        <p>
          9.10. <span>Technician Visits:</span> One of our technicians will come for a final measurement, and after
          that, again one of our technicians will come for Product fitting/installation.
        </p>
        <p>
          9.11. <span>Handover:</span> Handover of the installed Products should be given immediately as per the
          agreed closure document. Delaying the handover will subsequently delay further site
          installation.
        </p>
        <p>
          9.12. <span>Post-Installation Cleaning:</span> Cleaning of Aluminum windows / Glass will not be in our
          scope of work. After installation, in case frames, hardware, and glass are scratched or dirty due
          to working at site such as HVAC, civil contractors, P.O.P & paint works, it will not be our
          responsibility to clean the windows & glass. Any replacement if required will be on a chargeable
          basis.
        </p>

        <h4>10. Warranties & Liabilities</h4>
        <p>
          10.1. <span>Product Quality:</span> We take immense pride in the quality of work we do and use the best
          quality material available.
        </p>
        <p>
          10.2. <span>Specific Warranties: * Functional Hardware Warranty:</span>  Standard <span>12 months functional
            warranty </span> of hardware on manufacturing defect from the date of invoice.<span> * 10-Year Superior
              Finish Warranty:</span> We stand by the enduring beauty and durability of our powder coatings.
          Railingo offers a<span> 10-year warranty</span> against defects such as peeling, blistering, or significant
          chalking under normal use and proper maintenance. This ensures your products retain their
          stunning appearance for years to come, reflecting our commitment to lasting quality.
        </p>
        <p>
          10.3. <span>Service Warranty:</span> Railingo warrants that the services (e.g., measurement, installation)
          will be performed with reasonable care and skill. However, Railingo does not warrant that the
          services will be error-free or uninterrupted.
        </p>
        <p>
          10.4. <span>Warranty Exclusions:</span> This warranty does not cover: * Damage caused by misuse,
          abuse, or improper usage. * Damage caused by natural disasters or Acts of God/Riots/Terrorist
          acts/war/civil disturbance. * Damage caused by physical damage. * Damage caused by
          modifications to the Product without Railingo Pvt. Ltd.'s consent. * Damage caused by use of
          the Product with incompatible products. * Damage caused by improper installation (if not
          installed by us). * Normal wear and tear or improper maintenance/cleaning. * Damage caused
          by scratching or dirt after installation due to working at site (HVAC, POP, paint works etc.).

        </p>
        <p>
          10.5. <span>Glass Warranty Exclusion:</span> Glass is a fragile item and prone to break in nature. There is
          no warranty or guarantee on glass after installation, and any damage to the same will be
          charged extra for replacement.
        </p>
        <p>
          10.6. <span>Workmanship on Sealant:</span> There would be no guarantee of workmanship in silicone
          sealant filling; it is completely dependent on civil work and marble seal bonding.

        </p>
        <p>
          10.7. <span>Inspection & Reporting Defects:</span> Clients must thoroughly inspect installations upon
          completion and inform Railingo Pvt. Ltd. in writing within 36 hours of completion in case of any
          manufacturing defect. Railingo Pvt. Ltd. is not liable for any replacement after the
          aforementioned period.
        </p>
        <p>
          10.8. <span>Voiding Warranties:</span> Installed products must not be tampered with; any modifications
          without Railingo Pvt. Ltd.'s express written consent will immediately<span> void all applicable
            warranties</span>.
        </p>
        <p>
          10.9. <span>Limitation of Liability:</span> Railingo shall not be liable for any indirect, incidental,
          consequential, or special damages, even if advised of the possibility of such damages. To the
          maximum extent permitted by law, our total liability to you for any claims arising out of or relating
          to these Terms or your use of the Website or purchase of Products shall in no event exceed the
          amount paid by you for the specific Product or service giving rise to the claim.

        </p>

        <h4>11. Force Majeure</h4>
        <p>Railingo Pvt. Ltd. will not be liable for any delay or failure to perform its obligations arising from
          causes beyond its reasonable control, including, but not limited to, acts of God, natural
          disasters, war, terrorism, labor disputes, and government regulations. In such an event,
          timelines and obligations may be affected or suspended for the duration of the Force Majeure
          Event.
        </p>
        <h4>12. Miscellaneous Conditions</h4>
        <p>
          12.1. <span>Special Conditions:</span> Any special conditions or agreements reached between the Client
          and Railingo Pvt. Ltd. that deviate from these standard Terms must be documented in writing
          and signed by an authorized representative of Railingo Pvt. Ltd. to be considered valid.

        </p>
        <p>
          12.2. <span>Intellectual Property Rights:</span> All intellectual property rights, including but not limited to
          copyrights, trademarks, design rights, patents, and other proprietary rights, in and to the
          Website content (including text, graphics, logos, images, software, and their compilation) and all
          designs, drawings, specifications, technical data, and documentation developed or provided by
          Railingo Private Limited in connection with the Products and services, are and shall remain the
          exclusive property of Railingo Private Limited or its licensors. Unauthorized reproduction,
          distribution, modification, public display, or performance of any copyrighted material or
          intellectual property without the express written consent of Railingo Private Limited is strictly
          prohibited. Any designs, drawings, or specifications provided by the Company to You for
          customized products remain the sole intellectual property of Railingo Private Limited unless
          otherwise agreed in writing.
        </p>
        <p>
          12.3. <span>Confidentiality:</span> Railingo agrees to keep confidential all information disclosed by the
          Client in connection with the services. The Client agrees to keep confidential all information
          disclosed by Railingo in connection with the services.
        </p>
        <p>
          12.4. <span>Privacy Policy:</span> Your use of the Website is also governed by our Privacy Policy, which is
          incorporated herein by reference. Please review our Privacy Policy at<span> [Link to your Privacy
            Policy page, e.g., </span><Link href="https://www.railingo.com/privacy-policy/">www.railingo.com/privacy-policy</Link><span>]</span> to understand our practices regarding
          the collection, use, and disclosure of your personal information.

        </p>
        <p>
          12.5. <span>Links to Third-Party Websites:</span> The Website may contain links to third-party websites or
          services not owned or controlled by Railingo Private Limited. We have no control over, and
          assume no responsibility for, the content, privacy policies, or practices of any third-party
          websites.
        </p>
        <p>
          12.6. <span>Severability:</span> If any provision of these Terms is held to be invalid, illegal, or unenforceable
          for any reason, such provision shall be eliminated or limited to the minimum extent such that the
          remaining provisions of the Terms will continue in full force and effect.
        </p>
        <p>
          12.7. <span>Changes to These Terms:</span> We reserve the right, at our sole discretion, to modify or
          replace these Terms at any time. We will provide notice of any material changes by posting the
          updated Terms on our Website. Your continued use of the Website or engagement in
          transactions after the effective date of the revised Terms constitutes your acceptance of the
          changes.
        </p>

        <h4>13. Governing Law & Jurisdiction</h4>
        <p>
          All disputes arising out of or in connection with these Terms, or your use of the Website or
          purchase of Products from Railingo Pvt. Ltd., shall be governed by and construed in accordance
          with the laws of India. The parties agree to submit to the exclusive jurisdiction of the courts
          located in<span> Gurugram, Haryana, India.</span>
        </p>

        <h4>14. Contact Information</h4>
        <p>If you have any questions about these Terms, please contact us:</p>
        <address>
          <strong>Railingo Private Limited</strong>
          <br />
          <strong>Email:</strong>{" "}
          <a href="mailto:sales@railingo.com">sales@railingo.com</a>
          <br />
          <strong>Phone:</strong> +91 8755999395
          <br />
          <strong>Address: </strong>Plot no. 149, Sector 4, IMT Manesar, Gurugram, Haryana - 122051.
        </address>
      </div>
      <MainFooter />
    </div>
  );
};

export default TermsandCondition;
